(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('LaunchObjectTestViewController', LaunchObjectTestViewController);

    LaunchObjectTestViewController.$inject = ['$scope', '$state', 'ObjectTestResult', 'TestSchedule', 'ParseLinks', 'AlertService', 'id', 'testResults', '$timeout', '$uibModal', '$filter'];

    function LaunchObjectTestViewController($scope, $state, ObjectTestResult, TestSchedule, ParseLinks, AlertService, id, testResults, $timeout, $uibModal, $filter) {

        var vm = this;
        vm.objectTestResults = testResults;
        vm.objId = id;
        vm.running = false;

        vm.loadAll = function () {
            if(vm.objectTestResults.length > 0 && id != null) {
                vm.objectTestResults.forEach(function (test) {
                    test.running = false;
                });
                vm.runAll();
            }
            else {
                $state.transitionTo('launch-object-test', {
                    id: vm.objId
                });
            }
        };

        vm.runAll = function () {
            for (var i = 0; i < vm.objectTestResults.length; i++) {
                if(!vm.objectTestResults[i].objectTestSetting.manual){
                    vm.running = true;
                    vm.objectTestResults[i].running = true;
                    vm.runTest(vm.objectTestResults[i], i);
                }
            }
            vm.running = false;
        };

        vm.runTest = function (test, i) {
            $timeout(function () {
                ObjectTestResult.execute(test).$promise.then(
                    function (result) {
                        vm.objectTestResults[i] = result;
                        vm.objectTestResults[i].running = false;
                    },
                    function () {
                        AlertService.error("Test Error");
                    });
            }, 1000);
        };

        vm.scheduleTest = function () {
            if (vm.showSchedule === undefined)
                vm.response = {
                    single: false,
                    afterLaunch: true
                };
            $uibModal.open({
                templateUrl: 'app/entities/test-schedule/schedule-object-test.html',
                controller: 'ScheduleObjectTestController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: function () {
                        return vm.response;
                    }
                }
            }).result.then(function (result) {
                if (result.scheduleDateTime !== undefined || result.selectedDay !== undefined) {
                    vm.response = result;
                    vm.tabScheduleTest = {};
                    if (vm.response.single) {
                        setData();
                    } else {
                        setMultipleData();
                    }
                    vm.saveScheduleTest();
                } else
                    vm.showSchedule = undefined;
            })
        };

        function setData() {
            vm.tabScheduleTest.scheduleDateTime = vm.response.scheduleDateTime;
            vm.repeatNumber = vm.response.repeatNumber;
            convertDate();
        }

        function convertDate(){
            if(vm.repeatNumber) {
                var dateFormat = 'dd/MM/yyyy';
                var date = $filter('date')(new Date(vm.tabScheduleTest.scheduleDateTime), dateFormat);
                vm.showSchedule = "SCHEDULED: " + date + "\n" + " REPEAT EVERY " + vm.repeatNumber  + " " + "DAYS";
            } else {
                AlertService.error("Fill Repetition field");
                vm.showSchedule = undefined;
            }
        }

        function setMultipleData() {
            vm.tabScheduleTest.weeklyCron = [];
            vm.showSchedule = "SCHEDULED:\nREPEAT\n";
            angular.forEach(vm.response.selectedDay, function(day){
                if(day.selectedTime) {
                    var schedule = convertWeeklyDate(day);
                    vm.showSchedule += schedule;
                }
            });
            vm.showSchedule = vm.showSchedule.slice(0, -1);
        }

        function convertWeeklyDate(day) {
            var dateFormat = 'HH:mm';
            var tempDate = angular.copy(day.selectedTime);
            var date = $filter('date')(new Date(convertToUTC(tempDate)), dateFormat);
            var cron = date.split(":");
            vm.tabScheduleTest.weeklyCron.push(cron[1] + " " + cron[0] + " " + checkDay(day.day));

            var dateToShow = $filter('date')(new Date(day.selectedTime), dateFormat);
            return " " + day.day + " EVERY " + dateToShow + "\n";
        }

        function convertToUTC(date) {
            var offset = new Date().getTimezoneOffset();
            var hours = Math.floor(offset/60);
            var minutes = offset % 60;
            date.setHours(date.getHours() + hours);
            date.setMinutes(date.getMinutes() + minutes);
            return date;
        }

        function checkDay(day) {
            switch (day){
                case "MON":
                    return 1;
                case "TUE":
                    return 2;
                case "WED":
                    return 3;
                case "THU":
                    return 4;
                case "FRI":
                    return 5;
                case "SAT":
                    return 6;
                case "SUN":
                    return 7;
            }
        }

        vm.saveScheduleTest = function () {
            vm.isSaving = true;
            vm.tabScheduleTest.name = vm.response.testName;
            vm.tabScheduleTest.single = vm.response.single;
            if(vm.tabScheduleTest.single && vm.repeatNumber){
                vm.tabScheduleTest.cronExpression = vm.repeatNumber;
            }
            vm.tabScheduleTest.testResults = vm.objectTestResults;
            vm.tabScheduleTest.multipleSchedule = false; //it's a single object schedule
            vm.tabScheduleTest.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            TestSchedule.create(vm.tabScheduleTest, onSuccess, onError);

            function onSuccess() {
                vm.response = {
                    single: false,
                    afterLaunch: true
                };
            }
            function onError(error) {}
        };

        vm.loadAll();

        function getCheckedTestListId() {
            var checkedTestResultsId = "";
            vm.objectTestResults.forEach(function (test) {
                checkedTestResultsId = checkedTestResultsId + (checkedTestResultsId === "" ? "" : ",") + test.id;
            });
            return checkedTestResultsId;
        }

        vm.downloadPdf = function () {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.href = "api/object-test-result-pdf/" + id + "?test=" + getCheckedTestListId() +"&timeZone=" + encodeURI(Intl.DateTimeFormat().resolvedOptions().timeZone);
            a.setAttribute("target", "_blank");
            a.download = name[name.length - 1];
            a.click();
        };
    }
})();

